import * as Flags from 'country-flag-icons/react/3x2';

export const MenuItemsProducts = [
	{
		name : 'systems',
		path : '/products',
		cName : 'dropdown-link'
	},
	{
		name : 'acoustic_modems',
		path : '/acoustic_modems',
		cName : 'dropdown-link'
	},
	{
		name : 'positioning',
		path : '/usbl-product',
		cName : 'dropdown-link'
	},
	{
		name : 'software',
		path : '/software',
		cName : 'dropdown-link'
	},
	{
		name : 'accessoires',
		path : '/accessoires',
		cName : 'dropdown-link'
	}
];

export const MenuItemsLanguages = [
	{
		title: 'English',
		value: 'en',
		cName: 'dropdown-link',
		icon: Flags['GB']
	},
	{
		title: 'Русский',
		value: 'ru',
		cName: 'dropdown-link',
		icon: Flags['RU']
	},
	{
		title: '中文',
		value: 'ch',
		cName: 'dropdown-link',
		icon: Flags['CN']
	}
];

export const MenuItemsAboutUs = [
	{
		name : 'news' ,
		path :  '/news' ,
		cName : 'dropdown-link'
	},
	{
		name : 'contact' ,
		path : '/contact' ,
		cName : 'dropdown-link'
	}
];
